import { render, staticRenderFns } from "./NotificationSettingsWidget.vue?vue&type=template&id=67d826f3&"
import script from "./NotificationSettingsWidget.vue?vue&type=script&lang=js&"
export * from "./NotificationSettingsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports